import { render, staticRenderFns } from "./AssignedToRecordNotification.vue?vue&type=template&id=a878ba9c&scoped=true&"
import script from "./AssignedToRecordNotification.vue?vue&type=script&lang=js&"
export * from "./AssignedToRecordNotification.vue?vue&type=script&lang=js&"
import style0 from "./AssignedToRecordNotification.vue?vue&type=style&index=0&id=a878ba9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a878ba9c",
  null
  
)

export default component.exports